module.exports = __webpack_public_path__ + "static/media/negative-cricle.5e54dcab.svg";